var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineMdMenuToCloseTransition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#BDA100",
    strokeLinecap: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5L12 5L19 5"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    dur: "0.4s",
    values: "M5 5L12 5L19 5;M5 5L12 12L19 5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 12H19"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    dur: "0.4s",
    values: "M5 12H19;M12 12H12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 19L12 19L19 19"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    dur: "0.4s",
    values: "M5 19L12 19L19 19;M5 19L12 12L19 19"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineMdMenuToCloseTransition);
export default __webpack_public_path__ + "static/media/line-md--menu-to-close-transition.6e4df503503a86672477d0631d04b807.svg";
export { ForwardRef as ReactComponent };